import React from 'react'
import { withRouter } from "react-router-dom";
import { TableOp } from '../../../components/table/TableOps.tsx';
import TableComponent from '../../../components/table/TableOps';
import MotivoTarde from './MotivoTarde';
import ACCESS from '../../../ACCESS.js';

class MotivosTarde extends TableComponent {

  componentDidMount() {
    this.tableConfig(
      { dataUrl: 'motivo-tarde/filter', deleteUrl: 'motivo-tarde/delete', deleteField: 'motivo_nombre', modUrl: '/Catalogo/MotivoTarde' },
      TableOp.Table('Motivos de Entrega Tarde', [
        { label: 'Clave', id: 'motivo_clave' },
        { label: 'Descripcion', id: 'motivo_nombre' },
      ], [
        { id: 'edit', icon: 'edit', access: [ACCESS.CATALOGO_MOTIVOS_DE_ENTREGA_TARDE.EDITAR_CATALOGO] },
        { id: 'delete', icon: 'delete', access: [ACCESS.CATALOGO_MOTIVOS_DE_ENTREGA_TARDE.ELIMINAR_CATALOGO] },
      ]))
    this.table();
  }

  render() {

    return (
      <div>
        <div>
        {
             
          <MotivoTarde  onSave={() => {this.table()}}></MotivoTarde>
        }
        {
           
          <this.TableRender  />
        }
        </div>
      </div>
    )
  }
}

export default withRouter(MotivosTarde)